import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// Define a service using a base URL and expected endpoints
export const questionsApi = baseApi.injectEndpoints({
  reducerPath: "questionsApi",
  endpoints: (builder) => ({
    addQuestions: builder.mutation({
      query: (user) => {
        return {
          url: "question",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["question"],
    }),
    updateQuestions: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `question/${id}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["question"],
    }),
    deleteQuestions: builder.mutation({
      query: (id) => {
        return {
          url: `question/${id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["question"],
    }),
    getAllQuestions: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `question?${queryParams}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          //   authorization: `Bearer ${getToken()}`,
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["question"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddQuestionsMutation,
  useUpdateQuestionsMutation,
  useDeleteQuestionsMutation,
  useGetAllQuestionsQuery, // Add this line to import the query hook
} = questionsApi;
